<template>
  <v-container fluid>
    <SidebarNavigation />

    <v-card class="pa-2">
      <!-- FILTER -->
      <v-row dense align="center">
        <!-- Tahun -->
        <v-col cols="1.5">
          <v-select
            v-model="pagination.year"
            :items="yearOptions"
            label="Tahun"
            prepend-inner-icon="mdi-calendar"
            dense
            outlined
            hide-details
            clearable
            @change="onYearChange()"
          />
        </v-col>

        <!-- Worksheet -->
        <v-col cols="5">
          <v-autocomplete
            v-model="pagination.worksheet"
            :items="listWorksheet"
            label="Kertas Kerja Budget"
            prepend-inner-icon="mdi-file-document-outline"
            :item-text="(item) => `${item.worksheet_name}`"
            item-value="id"
            outlined
            dense
            clearable
            hide-details
            @change="onWorksheetChange"
          />
        </v-col>

        <!-- departement -->
        <v-col cols="3">
          <v-select
            v-model="pagination.departement_id"
            :items="listdepartement"
            label="Departement"
            prepend-inner-icon="mdi-office-building-outline"
            dense
            outlined
            clearable
            hide-details
            item-text="mst_division_name"
            item-value="mst_division_id"
            @change="ondepartementChange()"
          />
        </v-col>

        <!-- site -->
        <v-col cols="1.5">
          <v-select
            v-model="pagination.site_id"
            :items="listSite"
            label="Lokasi Kerja"
            prepend-inner-icon="mdi-office-building-outline"
            dense
            outlined
            clearable
            hide-details
            item-text="dc_code"
            item-value="mst_site_id"
            @change="onsiteChange()"
          />
        </v-col>

        <!-- corporate -->
        <v-col cols="4">
          <v-select
            v-model="pagination.corporate_id"
            :items="listCorporate"
            label="Perusahaan"
            prepend-inner-icon="mdi-office-building-outline"
            dense
            outlined
            clearable
            hide-details
            item-text="mst_corporate_name"
            item-value="mst_corporate_id"
            @change="oncorporateChange()"
          />
        </v-col>

        <!-- status -->
        <v-col cols="2">
          <v-select
            v-model="pagination.status"
            :items="listStatus"
            label="Status"
            dense
            outlined
            clearable
            hide-details
            item-text="name"
            item-value="id"
            @change="onStatusChange()"
          />
        </v-col>
        <v-col cols="2">
          <!-- SEARCH -->
          <v-text-field
            v-model="pagination.search"
            label="Search"
            append-icon="mdi-magnify"
            dense
            hide-details
            outlined
            @input="debouncedSearch"
          />
        </v-col>
      </v-row>

      <v-row dense align="center">
        <!-- Button -->
        <v-col cols="12" sm="4" md="6" lg="3">
          <v-btn
            color="primary"
            class="text-none px-5"
            elevation="2"
            @click="openDialogUploadExcel()"
          >
            <v-icon left small>mdi-plus</v-icon>
            Upload Realisasi
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <div class="table-wrapper">
            <v-data-table
              mobile-breakpoint="0"
              fixed-header
              dense
              class="elevation-5"
              :footer-props="{
                itemsPerPageOptions: [5, 10, 50, 100, -1],
              }"
              :headers="tableHeaders"
              :items="List"
              :items-per-page.sync="pagination.itemsPerPage"
              :page.sync="pagination.page"
              :sort-by="pagination.sortBy"
              :sort-desc="pagination.sortDesc"
              :loading="isLoading"
              :server-items-length="total"
              item-key="id"
              @update:page="updateQuery('page', $event)"
              @update:items-per-page="updateQuery('itemsPerPage', $event)"
              @update:sort-by="updateQuery('sortBy', $event)"
              @update:sort-desc="updateQuery('sortDesc', $event)"
            >
              <template v-slot:body="{ items }">
                <tbody>
                  <tr v-for="item in items" :key="item.id">
                    <td>{{ item.account }}</td>
                    <td>{{ item.account_combination }}</td>
                    <td>{{ item.transaksi_date }}</td>
                    <td>{{ item.item_name }}</td>
                    <td>{{ item.material_name }}</td>
                    <td>{{ item.spesification }}</td>
                    <td>{{ item.qty }}</td>
                    <td>{{ item.uom_name }}</td>
                    <td>{{ item.dc_code }}</td>
                    <td>{{ item.mst_corporate_name }}</td>
                    <td>{{ item.supplier_name }}</td>
                    <td>{{ item.departement_name }}</td>
                    <td>{{ formatRupiah(item.debit) }}</td>
                    <td>{{ formatRupiah(item.credit) }}</td>

                    <td class="text-center">
                      <v-chip
                        :color="getStatusColor(item.last_status)"
                        size="x-small"
                        variant="tonal"
                        class="text-caption text-capitalize text-center"
                        style="height: 20px"
                      >
                        {{ item.last_status }}
                      </v-chip>
                    </td>

                    <td class="text-center sticky-excel">
                      <v-btn
                        v-if="item.object_excel"
                        icon
                        size="x-small"
                        color="primary"
                        variant="text"
                        @click="openDialogExcel(item.object_excel)"
                      >
                        <v-icon size="16">mdi-file-eye</v-icon>
                      </v-btn>
                    </td>

                    <!-- AKSI -->
                    <td class="text-center sticky-action">
                      <v-tooltip text="Hapus data">
                        <template #activator="{ props }">
                          <v-btn
                            v-bind="props"
                            icon
                            size="small"
                            color="error"
                            variant="text"
                            @click="openDialogDeleteRealization(item)"
                          >
                            <v-icon>mdi-delete-outline</v-icon>
                          </v-btn>
                        </template>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <!-- Upload Excel Dialog -->
    <v-dialog v-model="isDialogOpenUploadExcel" max-width="800">
      <v-card rounded="xl" elevation="8">
        <!-- Header -->
        <v-toolbar flat color="primary" dark>
          <v-icon left> mdi-file-excel-outline </v-icon>

          <v-toolbar-title> Upload Excel Kartu Buku Besar</v-toolbar-title>

          <v-spacer />

          <v-btn icon @click="isDialogOpenUploadExcel = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pt-6">
          <v-row>
            <!-- Upload File -->
            <v-col cols="12">
              <v-form ref="uploadExcelForm" v-model="isFormValidUploadExcel">
                <v-file-input
                  v-model="excelUploadFormData.file"
                  label="Pilih File Excel"
                  prepend-icon=""
                  prepend-inner-icon="mdi-upload"
                  outlined
                  dense
                  show-size
                  counter
                  truncate-length="25"
                  accept=".xls,.xlsx"
                  :rules="[(v) => !!v || 'File wajib dipilih']"
                  hint="Format file: .xls atau .xlsx"
                  persistent-hint
                />
              </v-form>
            </v-col>

            <!-- Information -->
            <v-col cols="12">
              <v-alert type="info" dense text border="left">
                Pastikan kolom <b>DESCRIPTION</b> menggunakan format berikut:

                <br /><br />

                {ITEM} # {MATERIAL} # {SPESIFIKASI} # {QTY} {UOM} # {DEPARTEMEN}
                # {DC_CODE} # {MONTH} {YEAR} # {VENDOR}

                <br /><br />

                <b>Contoh:</b>

                <br /><br />

                STAPLER # PLASTIK # KECIL # 1 BUAH # FAA # DCKRN # DES 2026 # PT
                BARREN KARYA INDONESIA
              </v-alert>
            </v-col>
          </v-row>
        </v-card-text>

        <!-- Footer -->
        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer />

          <v-btn
            text
            color="secondary"
            @click="isDialogOpenUploadExcel = false"
          >
            Batal
          </v-btn>

          <v-btn
            color="primary"
            elevation="2"
            :disabled="!isFormValidUploadExcel"
            @click="submitUploadExcel"
          >
            <v-icon left> mdi-cloud-upload </v-icon>

            Upload
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- realization pending -->
    <v-dialog
      v-model="isDialogOpenRealizationPending"
      max-width="1200px"
      fullscreen
      persistent
    >
      <v-card class="rounded-xl">
        <!-- HEADER -->
        <v-card-title class="d-flex justify-space-between align-center">
          <!-- TITLE -->
          <div>
            <div class="text-h6 font-weight-bold">
              Realisasi Kartu Buku Besar
            </div>
            <div class="text-caption text-medium-emphasis">
              Review data sebelum submit
            </div>
          </div>

          <!-- ACTIONS -->
          <div class="d-flex align-center ga-2">
            <!-- REFRESH -->
            <v-tooltip
              text="Refresh Data Master"
              location="bottom"
              open-delay="200"
            >
            </v-tooltip>

            <!-- ADD ROW -->
            <v-tooltip
              text="Tambah Row Baru"
              location="bottom"
              open-delay="200"
            >
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon
                  color="primary"
                  size="small"
                  @click="addRow"
                >
                  <v-icon size="18">mdi-plus</v-icon>
                </v-btn>
              </template>
            </v-tooltip>

            <!-- CLOSE -->
            <v-tooltip text="Tutup Modal" location="bottom" open-delay="200">
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon
                  variant="text"
                  size="small"
                  @click="isDialogOpenRealizationPending = false"
                >
                  <v-icon size="18">mdi-close</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </div>
        </v-card-title>
        <v-divider></v-divider>

        <!-- CONTENT -->

        <v-data-table
          dense
          fixed-header
          class="elevation-1"
          :headers="tableHeadersRealizationPending"
          :items="listRealizationPending"
          :loading="isLoading"
          item-key="id"
          :items-per-page="5"
          :footer-props="{
            itemsPerPageOptions: [5],
          }"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td>
                  <div class="d-flex align-center ga-1">
                    <v-autocomplete
                      outlined
                      dense
                      class="custom-autocomplete"
                      style="width: 380px"
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-5"
                      v-model="item.worksheet_budget_id"
                      :items="listWorksheet || []"
                      :item-text="(item) => `${item.account} - ${item.name}`"
                      item-value="id"
                      hide-details="auto"
                      clearable
                      :search-input.sync="item.searchWorksheetBudget"
                      :error="!item.worksheet_budget_id"
                      :error-messages="
                        !item.worksheet_budget_id ? 'Wajib diisi' : null
                      "
                      @change="
                        submitUpdate('worksheet_budget_id', $event, item.id)
                      "
                    >
                      <!-- NO DATA -->
                      <template #no-data>
                        <div class="pa-2">
                          <div class="text-caption text-medium-emphasis mb-2">
                            Kertas Kerja Budget tidak ditemukan
                          </div>

                          <v-btn
                            block
                            color="primary"
                            variant="tonal"
                            rounded
                            prepend-icon="mdi-plus"
                            @click="openWorksheetBudgetDialog(item)"
                          >
                            Tambah "{{
                              item.searchWorksheetBudget ||
                              "Kertas Kerja Budget Baru"
                            }}"
                          </v-btn>
                        </div>
                      </template>
                    </v-autocomplete>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-center ga-1">
                    <v-autocomplete
                      outlined
                      dense
                      class="custom-autocomplete"
                      style="width: 320px"
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-5"
                      v-model="item.coa_id"
                      :items="listCoa || []"
                      item-text="account_combination"
                      item-value="id"
                      hide-details="auto"
                      clearable
                      :search-input.sync="item.searchCoa"
                      :error="!item.coa_id"
                      :error-messages="!item.coa_id ? 'Wajib diisi' : null"
                      @change="submitUpdate('coa_id', $event, item.id)"
                    >
                      <!-- NO DATA -->
                      <template #no-data>
                        <div class="pa-2">
                          <div class="text-caption text-medium-emphasis mb-2">
                            COA tidak ditemukan
                          </div>

                          <v-btn
                            block
                            color="primary"
                            variant="tonal"
                            rounded
                            prepend-icon="mdi-plus"
                            @click="openCoaDialog(item)"
                          >
                            Tambah "{{ item.searchCoa || "COA Baru" }}"
                          </v-btn>
                        </div>
                      </template>
                    </v-autocomplete>
                  </div>
                </td>
                <td>
                  <v-text-field
                    v-model="item.transaksi_date"
                    type="date"
                    variant="outlined"
                    density="compact"
                    hide-details
                    style="width: 140px"
                    @change="submitUpdate('transaksi_date', $event, item.id)"
                  />
                </td>
                <td>
                  <div class="d-flex align-center ga-1">
                    <v-autocomplete
                      outlined
                      dense
                      class="custom-autocomplete text-caption"
                      style="width: 250px"
                      variant="outlined"
                      density="comfortable"
                      bg-color="grey-lighten-5"
                      v-model="item.item_id"
                      :items="listItem || []"
                      :search-input.sync="item.searchItem"
                      item-text="name"
                      item-value="id"
                      clearable
                      :loading="item.loadingItem"
                      hide-details="auto"
                      :error="!item.item_id"
                      :error-messages="!item.item_id ? 'Wajib diisi' : null"
                      @change="submitUpdate('item_id', $event, item.id)"
                    >
                      <!-- NO DATA -->
                      <template #no-data>
                        <div class="pa-2">
                          <div class="text-caption text-medium-emphasis mb-2">
                            Item tidak ditemukan
                          </div>

                          <v-btn
                            block
                            color="primary"
                            variant="tonal"
                            rounded
                            prepend-icon="mdi-plus"
                            @click="openItemDialog(item)"
                          >
                            Tambah "{{ item.searchItem || "Item Baru" }}"
                          </v-btn>
                        </div>
                      </template>
                    </v-autocomplete>
                  </div>
                </td>

                <td>
                  <div class="d-flex align-center ga-1">
                    <v-autocomplete
                      outlined
                      dense
                      class="custom-autocomplete text-caption"
                      style="width: 250px"
                      variant="outlined"
                      density="comfortable"
                      bg-color="grey-lighten-5"
                      v-model="item.material_id"
                      :items="listMaterial || []"
                      :search-input.sync="item.searchMaterial"
                      item-text="name"
                      item-value="id"
                      clearable
                      :loading="item.loadingMaterial"
                      hide-details="auto"
                      :error="!item.material_id"
                      :error-messages="!item.material_id ? 'Wajib diisi' : null"
                      @change="submitUpdate('material_id', $event, item.id)"
                    >
                      <!-- NO DATA -->
                      <template #no-data>
                        <div class="pa-2">
                          <div class="text-caption text-medium-emphasis mb-2">
                            Item tidak ditemukan
                          </div>

                          <v-btn
                            block
                            color="primary"
                            variant="tonal"
                            rounded
                            prepend-icon="mdi-plus"
                            @click="openMaterialDialog(item)"
                          >
                            Tambah "{{
                              item.searchMaterial || "Material Baru"
                            }}"
                          </v-btn>
                        </div>
                      </template>
                    </v-autocomplete>
                  </div>
                </td>

                <td>
                  <v-text-field
                    v-model="item.spesification"
                    type="text"
                    variant="outlined"
                    density="compact"
                    hide-details
                    style="width: 300px"
                    @change="submitUpdate('spesification', $event, item.id)"
                  />
                </td>

                <td>
                  <v-text-field
                    v-model="item.qty"
                    type="number"
                    min="0"
                    variant="outlined"
                    density="compact"
                    class="text-center"
                    style="width: 80px"
                    :error="
                      item.qty === null || item.qty === '' || item.qty < 0
                    "
                    :error-messages="
                      item.qty === null || item.qty === ''
                        ? 'Wajib diisi'
                        : item.qty < 0
                        ? 'Tidak boleh minus'
                        : null
                    "
                    hide-details="auto"
                    @blur="submitUpdate('qty', item.qty, item.id)"
                  />
                </td>
                <td>
                  <div class="d-flex align-center ga-1">
                    <v-autocomplete
                      class="custom-autocomplete"
                      style="width: 120px"
                      variant="outlined"
                      density="comfortable"
                      bg-color="grey-lighten-5"
                      v-model="item.uom_id"
                      :items="listUom || []"
                      :search-input.sync="item.searchUom"
                      item-text="name"
                      item-value="id"
                      outlined
                      dense
                      hide-details="auto"
                      :error="!item.uom_id"
                      :error-messages="!item.uom_id ? 'Wajib diisi' : null"
                      clearable
                      :loading="item.loadingUom"
                      @change="submitUpdate('uom_id', $event, item.id)"
                    >
                      <!-- NO DATA -->
                      <template #no-data>
                        <div class="pa-2">
                          <div class="text-caption text-medium-emphasis mb-2">
                            UOM tidak ditemukan
                          </div>

                          <v-btn
                            block
                            color="primary"
                            variant="tonal"
                            rounded
                            prepend-icon="mdi-plus"
                            @click="openUomDialog(item)"
                          >
                            Tambah "{{ item.searchUom || "UOM Baru" }}"
                          </v-btn>
                        </div>
                      </template>
                    </v-autocomplete>
                  </div>
                </td>

                <td>
                  <v-autocomplete
                    class="custom-autocomplete"
                    style="width: 220px"
                    variant="outlined"
                    density="comfortable"
                    bg-color="grey-lighten-5"
                    v-model="item.site_id"
                    :items="listSite || []"
                    :search-input.sync="item.searchSite"
                    item-text="dc_code"
                    item-value="mst_site_id"
                    outlined
                    dense
                    hide-details="auto"
                    :error="!item.site_id"
                    :error-messages="!item.site_id ? 'Wajib diisi' : null"
                    clearable
                    :loading="item.loadingSite"
                    @change="submitUpdate('site_id', $event, item.id)"
                  />
                </td>

                <td>
                  <v-autocomplete
                    class="custom-autocomplete"
                    style="width: 380px"
                    variant="outlined"
                    density="comfortable"
                    bg-color="grey-lighten-5"
                    v-model="item.corporate_id"
                    :items="listCorporate || []"
                    :search-input.sync="item.searchCorporate"
                    item-text="mst_corporate_name"
                    item-value="mst_corporate_id"
                    outlined
                    dense
                    hide-details="auto"
                    :error="!item.corporate_id"
                    :error-messages="!item.corporate_id ? 'Wajib diisi' : null"
                    clearable
                    :loading="item.loadingSite"
                    @change="submitUpdate('corporate_id', $event, item.id)"
                  />
                </td>
                <td>
                  <div class="d-flex align-center ga-1">
                    <v-autocomplete
                      class="custom-autocomplete"
                      style="width: 320px"
                      variant="outlined"
                      density="comfortable"
                      bg-color="grey-lighten-5"
                      v-model="item.supplier_id"
                      :items="listSupplier || []"
                      :search-input.sync="item.searchSupplier"
                      item-text="name"
                      item-value="id"
                      outlined
                      dense
                      hide-details="auto"
                      :error="!item.supplier_id"
                      :error-messages="!item.supplier_id ? 'Wajib diisi' : null"
                      clearable
                      :loading="item.loadingSupplier"
                      @change="submitUpdate('supplier_id', $event, item.id)"
                    >
                      <!-- NO DATA -->
                      <template #no-data>
                        <div class="pa-2">
                          <div class="text-caption text-medium-emphasis mb-2">
                            Supplier tidak ditemukan
                          </div>

                          <v-btn
                            block
                            color="primary"
                            variant="tonal"
                            rounded
                            prepend-icon="mdi-plus"
                            @click="openSupplierDialog(item)"
                          >
                            Tambah "{{
                              item.searchSupplier || "Supplier Baru"
                            }}"
                          </v-btn>
                        </div>
                      </template>
                    </v-autocomplete>
                  </div>
                </td>

                <td>
                  <v-autocomplete
                    class="custom-autocomplete"
                    style="width: 340px"
                    variant="outlined"
                    density="comfortable"
                    bg-color="grey-lighten-5"
                    v-model="item.departement_id"
                    :items="listdepartement || []"
                    :search-input.sync="item.searchdepartement"
                    item-text="mst_division_name"
                    item-value="mst_division_id"
                    outlined
                    dense
                    hide-details="auto"
                    :error="!item.departement_id"
                    :error-messages="
                      !item.departement_id ? 'Wajib diisi' : null
                    "
                    clearable
                    :loading="item.loadingdepartement"
                    @change="submitUpdate('departement_id', $event, item.id)"
                  />
                </td>

                <td>
                  <v-text-field
                    v-model="item.debit"
                    type="number"
                    min="0"
                    variant="outlined"
                    density="compact"
                    class="text-right"
                    style="width: 140px"
                    :error="
                      item.debit === null || item.debit === '' || item.debit < 0
                    "
                    :error-messages="
                      item.debit === null || item.debit === ''
                        ? 'Wajib diisi'
                        : item.debit < 0
                        ? 'Tidak boleh minus'
                        : null
                    "
                    hide-details="auto"
                    @blur="formatNumber(item, 'debit')"
                    @change="submitUpdate('debit', item.debit, item.id)"
                  />
                </td>

                <td>
                  <v-text-field
                    v-model="item.credit"
                    type="number"
                    min="0"
                    variant="outlined"
                    density="compact"
                    class="text-right"
                    style="width: 140px"
                    :error="
                      item.credit === null ||
                      item.credit === '' ||
                      item.credit < 0
                    "
                    :error-messages="
                      item.credit === null || item.credit === ''
                        ? 'Wajib diisi'
                        : item.credit < 0
                        ? 'Tidak boleh minus'
                        : null
                    "
                    hide-details="auto"
                    @blur="formatNumber(item, 'credit')"
                    @change="submitUpdate('credit', item.credit, item.id)"
                  />
                </td>

                <td class="text-center sticky-excel">
                  <v-btn
                    v-if="item.object_excel"
                    icon
                    size="x-small"
                    color="primary"
                    variant="text"
                    @click="openDialogExcel(item.object_excel)"
                  >
                    <v-icon size="16">mdi-file-eye</v-icon>
                  </v-btn>
                </td>

                <!-- AKSI -->
                <td class="text-center sticky-action">
                  <v-tooltip text="Hapus data">
                    <template #activator="{ props }">
                      <v-btn
                        v-bind="props"
                        icon
                        size="small"
                        color="error"
                        variant="text"
                        @click="openDialogDeleteRealization(item)"
                      >
                        <v-icon>mdi-delete-outline</v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <v-divider></v-divider>

        <!-- ACTION -->
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>

          <v-btn
            variant="outlined"
            color="secondary"
            @click="submitUpdateRealizationStatus('cancel')"
          >
            Tutup
          </v-btn>

          <v-btn
            color="primary"
            :disabled="listRealizationPending.length === 0"
            @click="submitUpdateRealizationStatus('success')"
          >
            <v-icon start>mdi-check</v-icon>
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog excel referensi -->
    <v-dialog v-model="isDialogExcel" max-width="800px">
      <v-card class="rounded-lg">
        <v-card-title class="text-h6 font-weight-bold">
          Realisasi Kartu Buku Besar (Excel)
        </v-card-title>

        <v-divider />

        <v-card-text v-if="selectedExcel">
          <v-row dense>
            <v-col cols="6">
              <strong>K2:</strong><br />
              {{ selectedExcel.k2 }}
            </v-col>

            <v-col cols="6">
              <strong>ACC:</strong><br />
              {{ selectedExcel.acc }}
            </v-col>

            <v-col cols="6">
              <strong>NO_ACCOUNT:</strong><br />
              {{ selectedExcel.no_account }}
            </v-col>

            <v-col cols="6">
              <strong>DATE:</strong><br />
              {{ selectedExcel.date }}
            </v-col>

            <v-col cols="6">
              <strong>DESCRIPTION:</strong><br />
              {{ selectedExcel.description }}
            </v-col>

            <v-col cols="6">
              <strong>DEBIT:</strong><br />
              {{ selectedExcel.debit }}
            </v-col>

            <v-col cols="6">
              <strong>CREDIT:</strong><br />
              {{ selectedExcel.credit }}
            </v-col>

            <!-- <v-col cols="6">
              <strong>ENDING:</strong><br />
              {{ selectedExcel.ending }}
            </v-col> -->
          </v-row>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn variant="outlined" @click="isDialogExcel = false">
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DELETE CONFIRMATION DIALOG -->
    <v-dialog v-model="isDialogDeleteRealization" max-width="420" persistent>
      <v-card rounded="xl">
        <!-- Header -->
        <v-card-title class="d-flex align-center">
          <v-icon color="error" class="mr-2"> mdi-alert-circle-outline </v-icon>

          <span class="text-h6 font-weight-bold"> Konfirmasi Hapus </span>
        </v-card-title>

        <v-divider />

        <!-- Content -->
        <v-card-text class="py-6">
          <div class="text-body-1 mb-2">
            Apakah Anda yakin ingin menghapus data berikut?
          </div>

          <div class="pa-3 rounded-lg grey lighten-4 font-weight-medium">
            {{ selectedRealization?.item_name || "-" }}
          </div>

          <div class="caption mt-3 error--text">
            Data yang sudah dihapus tidak dapat dikembalikan.
          </div>
        </v-card-text>

        <v-divider />

        <!-- Footer -->
        <v-card-actions class="pa-4">
          <v-spacer />

          <v-btn text color="secondary" @click="closeDeleteDialog">
            Batal
          </v-btn>

          <v-btn
            color="error"
            depressed
            :loading="isDeletingRealization"
            @click="submitDeleteRealization"
          >
            <v-icon left> mdi-delete-outline </v-icon>

            Hapus
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar Notifications -->
    <snackbarMessage />

    <!-- dialog WorksheetBudget -->
    <DialogWorksheetBudget
      ref="dialogWorksheetBudget"
      @success="handleSuccessCreateWorksheetBudget"
    />

    <!-- dialog COA -->
    <DialogCoa ref="dialogCoa" @success="handleSuccessCreateCoa" />
    <!-- dialog Item -->
    <DialogItem ref="dialogItem" @success="handleSuccessCreateItem" />

    <!-- dialog Uom -->
    <DialogUom ref="dialogUom" @success="handleSuccessCreateUom" />

    <!-- dialog Supplier -->
    <DialogSupplier
      ref="dialogSupplier"
      @success="handleSuccessCreateSupplier"
    />
  </v-container>
</template>

<script>
import api from "@/utils/api";
import SidebarNavigation from "@/components/SidebarNavigation.vue";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";
import { getCurrentYearRange } from "@/utils/date";
import DialogWorksheetBudget from "@/components/DialogWorksheetBudget.vue";
import DialogCoa from "@/components/DialogCoa.vue";
import DialogItem from "@/components/DialogItem.vue";
import DialogUom from "@/components/DialogUom.vue";
import DialogSupplier from "@/components/DialogSupplier.vue";

export default {
  components: {
    SidebarNavigation,
    snackbarMessage,
    DialogWorksheetBudget,
    DialogCoa,
    DialogItem,
    DialogUom,
    DialogSupplier,
  },
  data() {
    const currentYear = new Date().getFullYear();
    return {
      selectedRealization: null,
      yearOptions: Array.from({ length: 6 }, (_, i) => currentYear - i),
      tableHeaders: [
        {
          text: "Account",
          align: "center",
          value: "account",
          sortable: false,
        },
        {
          text: "Account Combination",
          align: "center",
          value: "account_combination",
          sortable: false,
        },
        {
          text: "Tanggal",
          align: "center",
          value: "transaksi_date",
          sortable: false,
        },
        {
          text: "Item",
          align: "center",
          value: "item_name",
          width: "100px",
          sortable: false,
        },
        {
          text: "Material",
          align: "center",
          value: "material_name",
          width: "100px",
          sortable: false,
        },
        {
          text: "Spesifikasi",
          align: "center",
          value: "spesification",
          sortable: false,
        },
        {
          text: "qty",
          align: "center",
          value: "qty",
          width: "100px",
          sortable: false,
        },
        {
          text: "Satuan",
          align: "center",
          value: "uom_name",
          sortable: false,
        },
        {
          text: "Lokasi Kerja",
          align: "center",
          value: "dc_code",
          sortable: false,
        },
        {
          text: "Perusahaan",
          align: "center",
          value: "mst_corporate_name",
          sortable: false,
        },
        {
          text: "Supplier",
          align: "center",
          value: "supplier_name",
          sortable: false,
        },
        {
          text: "Departemen",
          align: "center",
          value: "departement_name",
          sortable: false,
        },
        {
          text: "Debit",
          align: "center",
          value: "debit",
          sortable: false,
        },
        {
          text: "Kredit",
          align: "center",
          value: "credit",
          width: "100px",
          sortable: false,
        },
        {
          text: "Status",
          align: "center",
          value: "last_status",
          width: "100px",
          sortable: false,
        },
        {
          text: "",
          align: "center",
          value: "object_excel",
          width: "60px",
          class: "sticky-excel",
          sortable: false,
        },
        {
          text: "",
          value: "actions",
          align: "center",
          width: "60px",
          class: "sticky-action",
          sortable: false,
        },
      ],
      tableHeadersRealizationPending: [
        {
          text: "Kertas Kerja Budget",
          align: "center",
          value: "worksheet_budget_id",
        },
        {
          text: "Account Combination",
          align: "center",
          value: "account_combination",
        },
        { text: "Tanggal", align: "center", value: "transaksi_date" },
        { text: "Item", align: "center", value: "item_name" },
        { text: "Material", align: "center", value: "material_name" },

        {
          text: "Spesifikasi",
          align: "center",
          value: "spesification",
          width: "300px",
        },
        { text: "qty", align: "center", value: "qty", width: "100px" },
        { text: "Satuan", align: "center", value: "uom_name" },
        { text: "Lokasi Kerja", align: "center", value: "dc_code" },
        { text: "Perusahaan", align: "center", value: "mst_corporate_name" },
        { text: "Supplier", align: "center", value: "supplier_name" },
        { text: "Departemen", align: "center", value: "departement_name" },
        { text: "Debit", align: "center", value: "debit" },
        { text: "Kredit", align: "center", value: "credit", width: "100px" },
        {
          text: "",
          align: "center",
          value: "object_excel",
          width: "60px",
          class: "sticky-excel",
        },
        {
          text: "",
          value: "actions",
          align: "center",
          sortable: false,
          width: "60px",
          class: "sticky-action",
        },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 5,
        sortBy: "id",
        sortDesc: false,
        startMenu: false,
        endMenu: false,
        startDate: getCurrentYearRange().start,
        endDate: getCurrentYearRange().end,
        search: "",
        status: "success",
        worksheet: "all",
        departement_id: "all",
        site_id: "all",
        corporate_id: "all",
        year: currentYear,
      },
      paginationPending: {
        page: 1,
        itemsPerPage: 5,
        sortBy: "id",
        sortDesc: false,
        startMenu: false,
        endMenu: false,
        startDate: getCurrentYearRange().start,
        endDate: getCurrentYearRange().end,
        search: "",
        status: "pending",
        worksheetPending: 1,
        departement_id: 1,
        year: currentYear,
      },
      total: 0,
      List: [],
      listRealizationPending: [],
      listItem: [],
      listMaterial: [],
      listCoa: [],
      listdepartement: [],
      listCorporate: [],
      listSite: [],
      listSupplier: [],
      listUom: [],
      listWorksheet: [],
      isLoading: false,
      isFormValidUploadExcel: false,
      excelUploadFormData: {
        file: null,
      },
      isDialogExcel: false,
      isDialogOpenUploadExcel: false,
      isDialogOpenRealizationPending: false,
      isDialogDeleteRealization: false,
      isDeletingRealization: false,
      listStatus: [
        // { name: "Pending", id: "pending" },
        // { name: "All", id: "all" },
        { name: "Success", id: "success" },
        // { name: "Cancel", id: "cancel" },
        // { name: "Rejected", id: "rejected" },
      ],
      selectedExcel: {},
      selectedItemPending: null,
    };
  },
  methods: {
    async fetchRealizationPending() {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.listRealizationPending = [];
      this.isLoading = true;
      const query = this.$route.query;
      const params = {
        page: parseInt(query.page) || this.pagination.page,
        limit: -1,
        search: query.search || this.pagination.search,
        sortBy: query.sortBy || this.pagination.sortBy || "id",
        sortDesc: query.sortDesc || this.pagination.sortDesc || true,
        startDate: query.startDate || this.pagination.startDate,
        endDate: query.endDate || this.pagination.endDate,
        lastStatus: "pending",
        worksheet: "all",
        year: query.year || this.pagination.year,
        // departementId: query.departementId || this.pagination.departement_id,
        departementId: "all",
        siteId: "all",
        corporateId: "all",
      };

      await api
        .get("/realization", { params })
        .then(({ data }) => {
          // console.log(data);
          this.listRealizationPending = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching suggestion:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },
    async fetchRealizationSuccess() {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoading = true;
      const query = this.$route.query;

      // console.log(this.pagination.departement_id);

      const params = {
        page: parseInt(query.page) || this.pagination.page,
        limit: parseInt(query.itemsPerPage) || this.pagination.itemsPerPage,
        search: query.search || this.pagination.search,
        sortBy: query.sortBy || this.pagination.sortBy || "id",
        sortDesc: query.sortDesc || this.pagination.sortDesc || true,
        startDate: query.startDate || this.pagination.startDate,
        endDate: query.endDate || this.pagination.endDate,
        lastStatus: query.status || this.pagination.status,
        worksheet: query.worksheet || this.pagination.worksheet,
        year: query.year || this.pagination.year,
        departementId: query.departementId || this.pagination.departement_id,
        siteId: query.siteId || this.pagination.site_id,
        corporateId: query.corporateId || this.pagination.corporate_id,
      };

      await api
        .get("/realization", { params })
        .then(({ data }) => {
          // console.log(data);
          this.List = data.data.data;
          this.total = data.data.total;
        })
        .catch((error) => {
          console.error("Error fetching suggestion:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },
    async fetchItem(item = null) {
      api
        .get("/items", {
          params: {
            search: item?.searchItem || "",
            sortBy: "id",
            sortDesc: "true",
            limit: -1,
          },
        })
        .then(({ data }) => {
          this.listItem = data.data.data;
          // console.log(this.listItem);
        })
        .catch((error) => {
          console.error("Error fetching item:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },

    async fetchMaterial(material = null) {
      api
        .get("/material", {
          params: {
            search: material?.searchMaterial || "",
            sortBy: "id",
            sortDesc: "true",
            limit: -1,
          },
        })
        .then(({ data }) => {
          this.listMaterial = data.data.data;
          // console.log(this.listmaterial);
        })
        .catch((error) => {
          console.error("Error fetching material:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    async fetchWorksheet(item = null) {
      api
        .get("/wb", {
          params: {
            search: item?.searchWorksheetBudget || "",
            sortBy: "id",
            sortDesc: "true",
            limit: -1,
          },
        })

        .then(({ data }) => {
          const worksheet = data.data.data;

          this.listWorksheet = [
            {
              id: "all",
              worksheet_name: "All",
            },
            ...worksheet,
          ];
        })
        .catch((error) => {
          console.error("Error fetching Worksheet:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    async fetchCoa(item = null) {
      store.dispatch("showLoading");

      api
        .get("/coa", {
          params: {
            search: item?.searchCoa || "",
            sortBy: "id",
            sortDesc: "true",
            limit: -1,
          },
        })
        .then(({ data }) => {
          this.listCoa = data.data.data || [];
        })
        .catch((error) => {
          console.error("Error fetching COA:", error);

          this.listCoa = [];
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    async fetchdepartement() {
      api
        .get("/divisions", { search: null })
        .then(({ data }) => {
          const department = data.data.data;

          this.listdepartement = [
            {
              mst_division_id: "all",
              mst_division_name: "All",
            },
            ...department,
          ];
        })
        .catch((error) => {
          console.error("Error fetching departement:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },

    async fetchCorporate() {
      try {
        const { data } = await api.get("/corporates", {
          params: {
            category: "GROUP",
          },
        });

        this.listCorporate = [
          {
            mst_corporate_id: "all",
            mst_corporate_name: "All",
          },
          ...(data?.data?.data || []).filter((e) =>
            e.mst_corporate_name?.toLowerCase().includes("fastana"),
          ),
        ];
      } catch (error) {
        store.dispatch("triggerSnackbar", {
          message: error?.response?.data?.message || "Failed fetch corporate",
          isSuccess: false,
        });
      } finally {
        store.dispatch("hideLoading");
      }
    },
    async fetchSite(item = null) {
      try {
        const { data } = await api.get("/sites", {
          params: {
            search: item?.searchSite || "",
            corporateId: 2,
          },
        });

        this.listSite = [
          {
            mst_site_id: "all",
            dc_code: "All",
          },
          ...(data?.data?.data || []).filter(
            (e) => ![1163, 1164, 1165, 1395, 4].includes(e.mst_site_id),
          ),
        ];
      } catch (error) {
        console.error("Error fetching site:", error);

        store.dispatch("triggerSnackbar", {
          message: error?.response?.data?.message || "Failed fetch site",
          isSuccess: false,
        });
      } finally {
        store.dispatch("hideLoading");
      }
    },
    async fetchSupplier(item = null) {
      api
        .get("/supplier", {
          params: {
            search: item?.searchSupplier || "",
            sortBy: "id",
            sortDesc: "true",
            limit: -1,
          },
        })
        .then(({ data }) => {
          this.listSupplier = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching supplier:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    async fetchUom(item = null) {
      api
        .get("/uom", {
          params: {
            search: item?.searchUom || "",
            sortBy: "id",
            sortDesc: "true",
            limit: -1,
          },
        })
        .then(({ data }) => {
          this.listUom = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching Uom:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },

    async openDialogUploadExcel() {
      await this.fetchRealizationPending();

      if (this.listRealizationPending.length > 0) {
        this.isDialogOpenRealizationPending = true;
      } else {
        this.listRealizationPending = [];
        this.isDialogOpenUploadExcel = true;
      }
    },

    async openDialogDeleteRealization(item) {
      this.selectedRealization = item;
      this.isDialogDeleteRealization = true;
    },

    async closeDeleteDialog() {
      this.isDialogDeleteRealization = false;
      this.selectedRealization = null;
    },

    async openDialogExcel(item) {
      this.selectedExcel = item;
      this.isDialogExcel = true;
    },

    async submitDeleteRealization() {
      if (!this.selectedRealization) return;

      this.isDeletingRealization = true;

      store.dispatch("showLoading");

      try {
        const payload = {
          status: "cancel",

          cart: [
            {
              id: this.selectedRealization.id,
            },
          ],
        };

        await api.post("/realization/update-status", payload);

        // Update frontend state
        this.listRealizationPending = this.listRealizationPending.filter(
          (row) => row.id !== this.selectedRealization.id,
        );

        // Update frontend state
        this.List = this.List.filter(
          (row) => row.id !== this.selectedRealization.id,
        );

        store.dispatch("triggerSnackbar", {
          message: "Data berhasil dihapus",
          isSuccess: true,
        });

        this.closeDeleteDialog();
      } catch (error) {
        let message = "Gagal menghapus data";

        if (error.response) {
          message = error.response.data?.message || message;
        } else if (error.message) {
          message = error.message;
        }

        store.dispatch("triggerSnackbar", {
          message,
          isSuccess: false,
        });

        console.error("Delete realization error:", error);
      } finally {
        this.isDeletingRealization = false;

        store.dispatch("hideLoading");
      }
    },
    async submitUploadExcel() {
      store.dispatch("showLoading");

      if (!this.excelUploadFormData.file) {
        store.dispatch("triggerSnackbar", {
          message: "File tidak boleh kosong !",
          isSuccess: false,
        });
        store.dispatch("hideLoading");
        return;
      }

      const formData = new FormData();

      // console.log(this.excelUploadFormData.file);

      formData.append("file", this.excelUploadFormData.file);
      // formData.append(
      //   "worksheet_budget_id",
      //   this.paginationPending.worksheetPending,
      // );

      // formData.forEach((value, key) => {
      //   console.log(key, value);
      // });

      api
        .post("/realization/upload-excel", formData)
        .then((response) => {
          const message = response.data.message;
          this.isDialogOpenUploadExcel = false;
          this.fetchRealizationSuccess();
          this.fetchRealizationPending();
          this.excelUploadFormData.file = null;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
          this.isDialogOpenRealizationPending = true;
        })
        .catch((error) => {
          let message = "Failed to save upload excel!";

          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", { message, isSuccess: false });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    async submitUpdateRealizationStatus(status) {
      store.dispatch("showLoading");
      const payload = {
        status: status,
        cart: this.listRealizationPending,
      };
      api
        .post("/realization/update-status", payload)
        .then((response) => {
          const message = response.data.message;
          this.isDialogOpenRealizationPending = false;
          if (status == "success") {
            store.dispatch("triggerSnackbar", { message, isSuccess: true });
          }
          this.fetchRealizationSuccess();
        })
        .catch((error) => {
          let message = "Failed to save paramater!";
          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },

    async submitUpdate(column, value, id) {
      if (!value) {
        return;
      }
      store.dispatch("showLoading");
      const payload = {
        column: column,
        value: value,
        id: id,
      };

      api
        .post("/realization/update", payload)
        .then((response) => {
          const message = response.data.message;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save paramater!";
          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          // this.fetchRealizationPending();
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    async submitUpdateRefresh(column, value, id) {
      if (!value) {
        return;
      }

      store.dispatch("showLoading");
      const payload = {
        column: column,
        value: value,
        id: id,
      };

      api
        .post("/realization/update", payload)
        .then((response) => {
          const message = response.data.message;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
          location.reload();
        })
        .catch((error) => {
          let message = "Failed to save paramater!";
          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    addRow() {
      store.dispatch("showLoading");
      const payload = {
        worksheet_budget_id: this.paginationPending.worksheetPending,
      };

      api
        .post("/realization", payload)
        .then((response) => {
          const message = response.data.message;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save paramater!";
          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.fetchRealizationPending();
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    debouncedSearch() {
      this.updateQuery("search", this.pagination.search);
    },
    updatePagination(query) {
      this.pagination.page = parseInt(query.page) || 1;
      this.pagination.itemsPerPage = parseInt(query.itemsPerPage) || 5;
      this.pagination.sortBy = query.sortBy || "id";
      this.pagination.sortDesc = query.sortDesc === "true" ? true : false;
      this.pagination.search = query.search || this.pagination.search || "";
      this.pagination.startDate = query.startDate || this.pagination.startDate;
      this.pagination.endDate = query.endDate || this.pagination.endDate;
      this.pagination.worksheet =
        parseInt(query.worksheet) || this.pagination.worksheet;
      this.pagination.departement_id =
        parseInt(query.departementId) || this.pagination.departement_id;
      this.pagination.year = parseInt(query.year) || this.pagination.year;
      this.pagination.status = query.status || this.pagination.status;
      this.pagination.site_id =
        parseInt(query.siteId) || this.pagination.site_id;

      this.pagination.corporate_id =
        parseInt(query.corporateId) || this.pagination.corporate_id;

      this.paginationPending.worksheetPending =
        parseInt(query.worksheetPending) ||
        parseInt(this.paginationPending.worksheetPending);
    },
    updateQuery(key, value) {
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePagination(this.$route.query);
    },
    getToday() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0"); // Bulan mulai dari 0
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`; // Format ISO
    },
    onDateChange(param) {
      if (param === "start") {
        this.updateQuery("startDate", this.pagination.startDate); // Update startDate
      } else {
        this.updateQuery("endDate", this.pagination.endDate); // Update endDate
      }
    },
    formatRupiah(value) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0, // Tidak ada angka desimal
      }).format(value);
    },

    formatNumber(item, field) {
      if (!item[field]) return;

      // pastikan number
      item[field] = Number(item[field]);
    },
    getStatusColor(status) {
      switch (status) {
        case "pending":
          return "warning";
        case "success":
          return "success";
        case "cancel":
          return "grey";
        case "rejected":
          return "error";
        default:
          return "default";
      }
    },
    openWorksheetBudgetDialog(item) {
      this.selectedItemPending = item;
      this.$refs.dialogWorksheetBudget.openDialogCreate(item);
    },
    openCoaDialog(item) {
      this.selectedItemPending = item;
      this.$refs.dialogCoa.openDialogCreate(item);
    },
    openItemDialog(item) {
      this.selectedItemPending = item;
      this.$refs.dialogItem.openDialogCreate(item);
    },
    openUomDialog(item) {
      this.selectedItemPending = item;
      this.$refs.dialogUom.openDialogCreate(item);
    },
    openSupplierDialog(item) {
      this.selectedItemPending = item;
      this.$refs.dialogSupplier.openDialogCreate(item);
    },

    async handleSuccessCreateWorksheetBudget(newWorksheetBudget) {
      await this.fetchWorksheet();
      await this.submitUpdate(
        "worksheet_budget_id",
        newWorksheetBudget.data.id,
        this.selectedItemPending.id,
      );

      this.selectedItemPending.worksheet_budget_id = newWorksheetBudget.data.id;
    },
    async handleSuccessCreateCoa(newCoa) {
      await this.fetchCoa();
      await this.submitUpdate(
        "coa_id",
        newCoa.data.id,
        this.selectedItemPending.id,
      );

      this.selectedItemPending.coa_id = newCoa.data.id;
    },
    async handleSuccessCreateItem(newItem) {
      await this.fetchItem();
      await this.submitUpdate(
        "item_id",
        newItem.data.id,
        this.selectedItemPending.id,
      );

      this.selectedItemPending.item_id = newItem.data.id;
    },

    async handleSuccessCreateMaterial(newMaterial) {
      await this.fetchMaterial();
      await this.submitUpdate(
        "material_id",
        newMaterial.data.id,
        this.selectedMaterialPending.id,
      );

      this.selectedItemPending.item_id = newMaterial.data.id;
    },
    async handleSuccessCreateUom(newUom) {
      await this.fetchUom();
      await this.submitUpdate(
        "uom_id",
        newUom.data.id,
        this.selectedItemPending.id,
      );
      this.selectedItemPending.uom_id = newUom.data.id;
    },
    async handleSuccessCreateSupplier(newSupplier) {
      await this.fetchSupplier();
      await this.submitUpdate(
        "supplier_id",
        newSupplier.data.id,
        this.selectedItemPending.id,
      );

      this.selectedItemPending.supplier_id = newSupplier.data.id;
    },

    onYearChange() {
      this.updateQuery("year", this.pagination.year); // Update endDa
    },
    onWorksheetChange() {
      this.updateQuery("worksheet", this.pagination.worksheet); // Update endDa
    },
    onsiteChange() {
      this.updateQuery("site_id", this.pagination.site_id); // Update endDate
    },

    oncorporateChange() {
      this.updateQuery("corporate_id", this.pagination.corporate_id); // Update endDate
    },

    onWorksheetChangePending() {
      this.isDialogOpenUploadExcel = false;
      this.updateQuery(
        "worksheetPending",
        this.paginationPending.worksheetPending,
      ); // Update endDate
    },

    ondepartementChange() {
      this.updateQuery("departementId", this.pagination.departement_id); // Update endDate
    },

    onStatusChange() {
      this.updateQuery("status", this.pagination.status); // Update endDate
    },
  },
  watch: {
    pagination: {
      async handler() {
        await this.fetchRealizationSuccess();
      },
      deep: true,
    },
    paginationPending: {
      async handler() {
        await this.fetchRealizationPending();
      },
      deep: true,
    },
  },
  async mounted() {
    store.commit("setTitle", "Realisasi");
    this.isLoading = true;

    await Promise.all([
      this.fetchCoa(),
      this.fetchItem(),
      this.fetchMaterial(),
      this.fetchdepartement(),
      this.fetchCorporate(),
      this.fetchSite(),
      this.fetchSupplier(),
      this.fetchUom(),
      this.fetchWorksheet(),
      this.fetchRealizationSuccess(),
    ]);
    this.updatePagination(this.$route.query), (this.isLoading = false);
  },

  computed: {
    user() {
      return store.getters["user/getUser"] || {}; // get Data User
    },
    title() {
      return store.state.title; // Mengakses title dari store
    },
  },
};
</script>

<style scoped>
.custom-autocomplete .v-field__input {
  font-size: 8px !important;
}

.custom-autocomplete .v-list-item-title {
  font-size: 8px !important;
}

.v-data-table thead th {
  text-align: center;
  vertical-align: middle;
}

.custom-table th,
.custom-table td {
  white-space: nowrap;
}

.table-wrapper table th,
.table-wrapper table td {
  white-space: nowrap;
}

.sticky-excel {
  position: sticky;
  right: 60px;
  background: white;
  z-index: 2;
}

.sticky-action {
  position: sticky;
  right: 0;
  background: white;
  z-index: 3;
}
</style>
